import React, { Component } from 'react'

export class CardColor extends Component {
    render() {
        return (
            <React.Fragment>
                <div className="col-md-12 mgt-15">
                    <h4 className="text-w-700 tcolor-black-2">Card Color</h4>
                </div>
                <div className="col-md-4 mgb-15">
                    <div className="card card-transparent">
                        <div className='card-header'>
                            <div className="card-title">Card Transparent</div>
                        </div>
                        <div className='card-body'>
                            <p className="card-text">
                                Some quick example text to build on the card title and make up the bulk of the card's content.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 mgb-15">
                    <div className="card card-primary">
                        <div className='card-header'>
                            <div className="card-title text-white">Card Primary</div>
                        </div>
                        <div className='card-body'>
                            <p className="card-text text-white">
                                Some quick example text to build on the card title and make up the bulk of the card's content.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 mgb-15">
                    <div className="card card-secondary">
                        <div className='card-header'>
                            <div className="card-title text-white">Card Secondary</div>
                        </div>
                        <div className='card-body'>
                            <p className="card-text text-white">
                                Some quick example text to build on the card title and make up the bulk of the card's content.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 mgb-15">
                    <div className="card card-success">
                        <div className='card-header'>
                            <div className="card-title text-white">Card Success</div>
                        </div>
                        <div className='card-body'>
                            <p className="card-text text-white">
                                Some quick example text to build on the card title and make up the bulk of the card's content.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 mgb-15">
                    <div className="card card-danger">
                        <div className='card-header'>
                            <div className="card-title text-white">Card Danger</div>
                        </div>
                        <div className='card-body'>
                            <p className="card-text text-white">
                                Some quick example text to build on the card title and make up the bulk of the card's content.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 mgb-15">
                    <div className="card card-warning">
                        <div className='card-header'>
                            <div className="card-title text-white">Card Warning</div>
                        </div>
                        <div className='card-body'>
                            <p className="card-text text-white">
                                Some quick example text to build on the card title and make up the bulk of the card's content.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 mgb-15">
                    <div className="card card-info">
                        <div className='card-header'>
                            <div className="card-title text-white">Card Info</div>
                        </div>
                        <div className='card-body'>
                            <p className="card-text text-white">
                                Some quick example text to build on the card title and make up the bulk of the card's content.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 mgb-15">
                    <div className="card card-Light">
                        <div className='card-header'>
                            <div className="card-title">Card Light</div>
                        </div>
                        <div className='card-body'>
                            <p className="card-text">
                                Some quick example text to build on the card title and make up the bulk of the card's content.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 mgb-15">
                    <div className="card card-dark">
                        <div className='card-header'>
                            <div className="card-title text-white">Card Dark</div>
                        </div>
                        <div className='card-body'>
                            <p className="card-text text-white">
                                Some quick example text to build on the card title and make up the bulk of the card's content.
                            </p>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default CardColor
